import { $qs, $qsa } from './utils/QuerySelector';
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger);

function scrollAnimations () {
	
	// Scroll animations system with GSAP
	let sections = gsap.utils.toArray('[twk-aos]');
	let onFirstBlock = false;

	if ( ScrollTrigger ) {
		ScrollTrigger.refresh();
	}

	// console.log(sections);
	sections.forEach((section) => {
		// Check if the section is the first block on the main container.
		// We want it to animate earlier than the others.
		if ( section.closest('section') !== null ){
			const parent         = document.querySelector('main.main');
			const firstSectionId = parent?.firstElementChild.id

			if ( section.closest('section').id === firstSectionId ) {
				onFirstBlock = true;
			} else {
				onFirstBlock = false;
			}
		}

		section.classList.add( 'twk-aos-animate' )  // Marks that js is loaded and the block is ready to be animated.

		// Defaults
		let twkAosTrigger  = ( onFirstBlock ? 'top bottom' : "top bottom-=50px" );
		let twkAosDuration = 1.4;
		let twkAosDelay    = '<';
		let twkAosMarker   = false;
		let twkAosMarkerId = 'section';

		if ( section.getAttribute('twk-aos-trigger') !== null ){
			twkAosTrigger = section.getAttribute('twk-aos-trigger');
		}
		if ( section.getAttribute('twk-aos-duration') !== null ){
			twkAosDuration = section.getAttribute('twk-aos-duration') / 1000;            // From html we get them in milliseconds
		}
		if ( section.getAttribute('twk-aos-delay') !== null ){
			twkAosDelay = section.getAttribute('twk-aos-delay') / 1000;                  // From html we get them in milliseconds
		}
		if ( section.getAttribute('twk-aos-marker') !== null ){
			twkAosMarker  = true;
			twkAosMarkerId = section.getAttribute('twk-aos-marker');
		}


		/* 
		// Log data.
		console.table({
			'twk-aos-trigger' : { 'Value': twkAosTrigger },
			'twk-aos-duration' : {'Value': twkAosDuration },
			'twk-aos-delay' : {'Value': twkAosDelay },
			'twk-aos-marker' : {'Value': twkAosMarker },
			'HTML' : {'Value': section }
		});
		*/


		let tl = gsap.timeline({
			defaults: {
				duration: twkAosDuration,
				ease: "power1.out"
				
				//ease: CustomEase.create("customEase", "0.215, 0.61, 0.355, 1")
			},
			scrollTrigger: {
				trigger: section,
				// fastScrollEnd: true,
				// once: true,
				start: twkAosTrigger,
				// end: "bottom 80%",
				// id: twkAosMarkerId,
				markers: twkAosMarker,
				// triggerHook: 1,
				onLeave: () => section.classList.add('twk-aos-animated'),
			}
		});

		ScrollTrigger.sort();

		/**
		 * Scroll animations
		 * 
		 * Options:
		 * fade, fade-up, fade-down, fade-left, fade-right
		 * slide-up, slide-down, slide-left, slide-right
		 * zoom-in, zoom-out
		 */
		let animationObject;
		let animationToObject;
		let animationAttr = section.getAttribute('twk-aos');

		// Create the GSAP object for the animation depending on the twk-aos attribute.
		switch ( animationAttr ) {
			case 'fade':
				animationObject = { autoAlpha: 0 }
				animationToObject = { autoAlpha: 1 }
				break;
			case 'fade-up':
				animationObject = { autoAlpha: 0, x:0, y: '200px' }
				animationToObject = { autoAlpha: 1, x: 0, y: '0px' }
				break;
			case 'fade-down':
				animationObject = { autoAlpha: 0, x: 0, y: '-100px' }
				animationToObject = { autoAlpha: 1, x: 0, y: '0px' }
				break;
			case 'fade-left':
				animationObject = { autoAlpha: 0, xPercent: '100', y: 0 }
				animationToObject = { autoAlpha: 1, xPercent: '0', y: 0 }
				break;
			case 'fade-right':
				animationObject = { autoAlpha: 0, xPercent: '-100', y: 0 }
				animationToObject = { autoAlpha: 1, xPercent: '0', y: 0 }
				break;
			case 'slide-up':
				animationObject = { x: 0, y: '200px' }
				animationToObject = { x: 0, y: '0' }
				break;
			case 'slide-down':
				animationObject = { x: 0, y: '-100px' }
				animationToObject = { x: 0, y: '0' }
				break;
			case 'slide-left':
				animationObject = { xPercent: '100', y: 0 }
				animationToObject = { xPercent: '0', y: 0 }
				break;
			case 'slide-right':
				animationObject = { xPercent: '-100', y: 0 }
				animationToObject = { xPercent: '0', y: 0 }
				break;
			case 'zoom-in':
				animationObject = { scale: 0.7 }
				animationToObject = { scale: 1 }
				break;
			case 'zoom-out':
				animationObject = { scale: 1.1 }
				animationToObject = { scale: 1 }
				break;
			case 'fade-zoom-in':
				animationObject = { autoAlpha: 0, scale: 0.5 }
				animationToObject = { autoAlpha: 1, scale: 1 }
				break;
		
			default:
				animationObject = { autoAlpha: 0 }
				animationToObject = { autoAlpha: 1 }
				break;
		}
		

		// Log data.
		/* console.table({
			'section' : { 'Value': section },
			'animationObject' : { 'Value': JSON.stringify( animationObject ) },
			'animationToObject' : { 'Value': JSON.stringify( animationToObject ) },
			'twkAosDelay' : { 'Value': JSON.stringify( twkAosDelay ) },
		});
		console.log(section); */
		tl.fromTo( section, animationObject, animationToObject, twkAosDelay)
		
	});

	// parallax title
	var parallaxTitle = $qs('.js-parallax-title');
	
	if(parallaxTitle) {	
		gsap.fromTo(parallaxTitle, {
			xPercent: 0,        
		}, {
			xPercent: -20,
			scrollTrigger: {
				trigger : parallaxTitle ,
				scrub: 1.2,
				start: `top center`
			}
		})
	}
}


export default scrollAnimations;